var productImgArray = [];
var $product_carousel = $('#productImg').flickity();
var $containColor = $('#containColor').val();

$(function(){
  if ($containColor == 'true') {
    getAllProductImage();
    imgChanger(0); //Execute the function onload
    // initThumbnailFlickity();
  }
})

getAllProductImage = () =>{
  $('.product_image').each(function(){
    var slideContent = $(this);
    productImgArray = productImgArray.concat(slideContent);
  });
}
getAllProductThumbnailImage = () =>{
  $('.js-thumbnail').each(function(){
    var thumbnailContent = $(this);
    // console.log('out',thumbnailContent);
    productThumbnailImgArray = productThumbnailImgArray.concat(thumbnailContent);
  });
}
// Function for change image base on variant
imgChanger = (checkOnload) =>{
  if ($(window).width() <= 1007) {
    $product_carousel.flickity('destroy')
  }
  var VariantValue = '';
  //This function is to get all Swatch value and combine them together==============||
  //Get individual selected variant e.g. Color: Blue, Size: M, Material: Fabric     ||
  //Result: Combine the individual selected value ==> Blue-M-Fabric-                ||
  /*||*/$('.HorizontalList__Item:not(.addon) > .ColorSwatch__Radio, .HorizontalList__Item:not(.addon) > .block_swatch').each(function(){          /*||*/
  /*||*/  var $this = $(this);                                                    /*||*/
  /*||*/  if ($this.prop('checked')) {                                            /*||*/
  /*||*/    var $thisVal = $this.attr('data-variant-value');                      /*||*/
  /*||*/    VariantValue += $thisVal + '-';                                       /*||*/
  /*||*/                                            /*||*/
  /*||*/  }                                                                       /*||*/
  /*||*/});                                                                       /*||*/
  //================================================================================||
  VariantValue = VariantValue.replace(/-\s*$/, ""); //Remove the last dash(-) from the string from Blue-M-Fabric- to Blue-M-Fabric
  //Hide all Image start here
  // var thumbnails = jQuery('.thumbnailImg');

  var product_img = jQuery('.js-product_img');
  // Hide all image ends here

    //Show the selected variant image starts here

    product_img.each(function(){

      var wrapper = $(this);
      // console.log('what is this',wrapper.parent().parent());
      wrapper.parent().parent().remove();
      for (var i = 0; i < productImgArray.length; i++) {
          var altVal = productImgArray[i].attr('data-imgalt');
          if (altVal == VariantValue || altVal == 'main_image') {
            $('#productImg').append( productImgArray[i] );
          }
        }
    });
    //Show the selected variant image ends here
  //Show the selected variant thumbnail image starts here
    // thumbnails.each(function() {
    //   var wrapper = $(this);
    //   wrapper.parent().remove();
    //   for (var i = 0; i < productThumbnailImgArray.length; i++) {
    //     if ( productThumbnailImgArray[i].children().attr('alt') == VariantValue ) {
    //       if (checkOnload == 0) {
    //         $('#flickityThumbnail').append( productThumbnailImgArray[i] );
    //       } else if (checkOnload == 1) {
    //          $('#flickityThumbnail .flickity-slider').append( productThumbnailImgArray[i] );
    //       }
    //       // console.log("it's time, it's time, it's time",productThumbnailImgArray[i]);
    //     }
    //   }


  // });
  //Show the selected variant image ends here
  initFlickity();
  // $productThumbnail_carousel.flickity().flickity('destroy');
  if ($(window).width() > 1007) {
    initThumbnailFlickity();
  }else{
    $(".Product__SlideshowMobileNav").hide();
  }
}

// Everytime when the user select a variant Execute this function
// Change variant image on click
$('.HorizontalList__Item:not(.addon) > .ColorSwatch__Radio, .HorizontalList__Item:not(.addon) > .block_swatch').on('click',function(){
  // console.log('here',this);
  setTimeout(function(){
    imgChanger(1);
  },500);
});

initFlickity = () =>{
  if ($(window).width() <= 1007) {
    $('#productImg').flickity({
      "prevNextButtons": false,
      "pageDots": true,
      "adaptiveHeight": true,
      "dragThreshold": 8,
      "arrowShape": {"x0": 20, "x1": 60, "y1": 40, "x2": 60, "y2": 35, "x3": 25}
    });
  }
  else {
    _prod_gallery._setupDeviceFeatures();
    _prod_gallery._attachListeners();

  }
}

initThumbnailFlickity = () =>{
  $('.Product__SlideshowNavDot').hide();
  $('.product_image').each(function(){
    var _n = $(this).data('num');
    $('.product-dots-'+_n).show();
  })
}

/* change product main image when bold product options swatches are clicked */
// BOLD.common.settings.log_events = true; // logs only event names
// BOLD.common.settings.log_event_data = true; // also logs event data
// BOLD.options.app.on('dom_loaded', function(data){ 
//   getAllProductImage();
// });

// BOLD.options.app.on('option_changed', function(data){ 
//   var productSelected = data.data.value[0];
//   if (data.data.option.DOM.templateType == "swatch" && typeof productSelected !== "undefined"){
//     boldImgChanger(productSelected);
//   }
// });

// boldImgChanger = (VariantValue) =>{
//   if ($(window).width() <= 1007) {
//     $product_carousel.flickity('destroy')
//   }
//   var product_img = jQuery('.js-product_img');
//   product_img.each(function(){
//     var wrapper = $(this);

//     wrapper.parent().parent().remove();
//     for (var i = 0; i < productImgArray.length; i++) {
//         var altVal = productImgArray[i].attr('data-imgalt');
//         if (altVal == VariantValue || altVal == 'main_image') {
//           $('#productImg').append( productImgArray[i] );
//         }
//       }
//   });
//   initFlickity();
//   if ($(window).width() > 1007) {
//     initThumbnailFlickity();
//   }
// }

